var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","d":"m0 8 1.5-1.5L7 12V0h2v12l5.5-5.5L16 8l-8 8z"}));
}

ArrowDown.defaultProps = {"width":"16","height":"16","fill":"none","viewBox":"0 0 16 16"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
